"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const service_ticket_entity_1 = require("./service-ticket.entity");
const ticket_evidence_entity_1 = require("./ticket-evidence.entity");
const tickets_service_1 = require("./tickets.service");
const tickets_controller_1 = require("./tickets.controller");
const evidence_controller_1 = require("./evidence.controller");
const customers_module_1 = require("../customers/customers.module");
const notifications_module_1 = require("../notifications/notifications.module");
let TicketsModule = class TicketsModule {
};
exports.TicketsModule = TicketsModule;
exports.TicketsModule = TicketsModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([service_ticket_entity_1.ServiceTicket, ticket_evidence_entity_1.TicketEvidenceLink]),
            customers_module_1.CustomersModule,
            notifications_module_1.NotificationsModule,
        ],
        providers: [tickets_service_1.TicketsService],
        controllers: [tickets_controller_1.TicketsController, evidence_controller_1.EvidenceController],
        exports: [tickets_service_1.TicketsService],
    })
], TicketsModule);
